<div class="success-modal">
  <div class="success-badge">
    <svg-icon src="assets/icons/checkmark.svg" class="success-badge-icon"></svg-icon>
  </div>
  <h3 class="success-title">{{ data.title }}</h3>
  <p class="success-message">{{ data.message }}</p>
  <button type="button" class="success-done" (click)="done()">{{ buttonLabel }}</button>
</div>
